import * as TranslatedResourceActions from './TranslatedResourceActions';

const initialState = {
  data: [],
};

export default function translatedResource(state = initialState, action) {
  switch (action.type) {
    case TranslatedResourceActions.LOAD_TRANSLATED_RESOURCE:
      return {
        ...state,
        data: action.data.translated_resources
      };

    default:
      return state;
  }
}
